// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__Zc9_r","footer":"ModalCreateQualiphyProcedure_footer__2zml4","additionData":"ModalCreateQualiphyProcedure_additionData__2mWIw"};